module.exports = __webpack_public_path__ + "media/images/pc/visit_reserve/about-confirm-e4ce3392b2fa679902394219d16d5e96.png";